import { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const MAPS_API_KEY = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string) || '';

interface MapsContextValue {
  mapsLoaded: boolean;
  mapsLoadError: Error | undefined;
}

const MapsContext = createContext<MapsContextValue>({ mapsLoaded: false, mapsLoadError: undefined });

/**
 * Mount once inside DashboardLayout so the Google Maps JS API is loaded
 * exactly once for the entire session. Avoids the singleton reference-count
 * dropping to zero when individual pages unmount during navigation, which
 * causes @react-google-maps/api to reset and reload the full 400 KB script.
 */
export function MapsProvider({ children }: { children: React.ReactNode }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'chekit-maps',
    googleMapsApiKey: MAPS_API_KEY,
  });

  return (
    <MapsContext.Provider value={{ mapsLoaded: isLoaded, mapsLoadError: loadError }}>
      {children}
    </MapsContext.Provider>
  );
}

export function useMaps() {
  return useContext(MapsContext);
}
